// @ts-strict-ignore
import React, { useContext } from 'react';
import {
  Button,
  ButtonSize,
  ButtonVariant,
  Separator,
} from '@usealloy/component-library';
import { IsolatedEditorContainer } from 'flow/editor/styles';
import {
  StyledTipCallout,
  StyledAggregationCriteriaContainer,
  StyledAggregationSubEditorLayout,
  StyledAggregationSubEditorRow,
  StyledAggregationSubEditorActions,
} from './styles';
import BaseAggregationsSection from './BaseAggregationsSection';
// import AggregationFiltersSection from './AggregationFiltersSection';
import AggregationNameAndDescription from './AggregationNameAndDescription';
import { AggregationEditorContext } from './context';
import { useAppDispatch } from '~/store/reduxHooks';
import { RuleEditorContext } from '../NodeEditorDrawer/context';
import { updateThreshold as updateThresholdSlice } from 'flow/store/redux/slice';
import type { PopulatedThreshold } from 'flow/store/engine/types';
import {
  sourceDataToAggregationComponents,
  aggregationComponentsToSourceData,
} from './transformers';
import { AggregationEditorOrigin } from '../NodeEditorDrawer/types';

type AggregationsSubEditorContainerProps = {
  data: { threshold: PopulatedThreshold };
};

const AggregationsSubEditorContainer = ({ data }: AggregationsSubEditorContainerProps) => {
  const dispatch = useAppDispatch();
  const { setIsolatedEditingBlock } = useContext(RuleEditorContext);
  const {
    sourceData, setSourceData, handleClose, aggregationEditorContainerRef, origin,
  } = useContext(
    AggregationEditorContext,
  );
  const { threshold } = data;

  const thresholdSide = origin === AggregationEditorOrigin.THRESHOLD_LEFT ? 'left' : 'right';

  const handleSave = () => {
    if (!threshold) {
      handleClose();
      return;
    }
    dispatch(updateThresholdSlice({
      path: `${threshold.publicId}.${thresholdSide}.aggregationComponents`,
      value: sourceDataToAggregationComponents(
        sourceData,
        threshold[thresholdSide].aggregationComponents,
      ),
    }));
    handleClose();
  };

  const clearAggregationsSubEditorState = () => {
    handleClose();
    setSourceData(aggregationComponentsToSourceData(
      threshold[thresholdSide].aggregationComponents,
    ));
    setIsolatedEditingBlock({
      originPublicId: undefined,
      originType: undefined,
      originCaretIndex: undefined,
    });
  };

  return (
    <IsolatedEditorContainer ref={aggregationEditorContainerRef}>
      <StyledAggregationSubEditorLayout>
        <StyledAggregationSubEditorRow>
          <StyledAggregationCriteriaContainer>
            <StyledTipCallout text="Build your custom aggregation by selecting the options below." />
            <BaseAggregationsSection />
            {/* <AggregationFiltersSection /> */}
          </StyledAggregationCriteriaContainer>
          <AggregationNameAndDescription />
        </StyledAggregationSubEditorRow>
        <Separator />
        <StyledAggregationSubEditorActions>
          <Button
            size={ButtonSize.small}
            variant={ButtonVariant.secondary}
            onClick={clearAggregationsSubEditorState}
          >
            Cancel
          </Button>
          <Button
            size={ButtonSize.small}
            variant={ButtonVariant.primary}
            onClick={handleSave}
            disabled={!threshold
              || !sourceData.name
              || !sourceData.description}
          >
            Done
          </Button>
        </StyledAggregationSubEditorActions>
      </StyledAggregationSubEditorLayout>
    </IsolatedEditorContainer>
  );
};

export default AggregationsSubEditorContainer;
